import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  width: "512",
  height: "512",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "256",
  cy: "256",
  r: "256",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  width: "512",
  height: "512",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M82.0536 75.9343H508.86L474.995 222.674L383.948 277.355L458.178 374.125L381.943 436.066L299.164 328.275L149.879 417.927H3.13989C29.4493 303.932 55.7441 189.937 82.0536 75.9343ZM398.583 174.173L401.04 163.539H149.456L110.968 330.316H133.826L398.583 174.173Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_icon = _resolveComponent("n-icon")!

  return (_openBlock(), _createBlock(_component_n_icon, { size: _ctx.size }, {
    default: _withCtx(() => [
      (_ctx.name === 'DUNE')
        ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
        : (_ctx.name === 'HPO')
          ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["size"]))
}